module.exports = __webpack_public_path__ + "img/title-2.168a220b.png";